/* eslint-disable import/no-unresolved */
import React from 'react';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import SearchFilterSocios from 'src/components/leads/searchFilterSocios';
import EstablecimientosAdd from 'src/components/leads/establecimientos/EstablecimientosAdd';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import EstablecimientoDetails from 'src/components/leads/establecimientoDetails/EstablecimientoDetails';
import TableType4 from '@auteco/components/sharedComponents/Tablas/TableType4/TableType4';
import { useStyles } from './styles';

const EstablecimientosPage = (props) => {
  const classes = useStyles();

  const {
    form,
    vertical,
    isEdit,
    details,
    controls,
    ciudades,
    vehiculos,
    onOpenForm,
    onCloseForm,
    openDetails,
    permitValue,
    openAddForm,
    handleSubmit,
    handleChange,
    handleDelete,
    onOpenDetails,
    departamentos,
    filteredCities,
    onChangeInputs,
    establecimientos,
    controlComponent,
    handleChangeDepartment,
  } = props;

  const columnsLeads = [
    {
      title: 'ID',
      field: 'id',
      editable: 'never',
      hidden: true,
    },
    {
      title: 'CODIGO DESTINATARIO',
      field: 'codigo_destinatario',
      editable: 'never',
    },
    { title: 'NOMBRE', field: 'nombre_establecimiento', editable: 'never' },
    { title: 'NIT', field: 'nit', editable: 'never' },
    { title: 'CORREO', field: 'correo_electronico', editable: 'never' },
    { title: 'DEPARTAMENTO', field: 'departamento', editable: 'never' },
    { title: 'CIUDAD', field: 'ciudad', editable: 'never' },
    {
      title: 'INTEGRACION',
      field: 'token_integracion',
      editable: 'never',
      hidden: true,
    },
    { title: 'SCORE', field: 'score' },
    {
      title: 'SCORE ACTAS',
      field: 'score_actas',
    },
    {
      title: 'TIEMPO GESTIÓN',
      field: 'tiempo_gestion',
      render: (rowData) => <td>{`${rowData.tiempo_gestion} Horas`}</td>,
    },
    {
      title: 'TASA CONVERSIÓN',
      field: 'tasa_conversion',
      render: (rowData) => <td>{`${rowData.tasa_conversion} %`}</td>,
    },

    {
      title: 'CONVERSIÓN ACTAS',
      field: 'tasa_conversion_actas',
      render: (rowData) => <td>{`${rowData.tasa_conversion_actas} %`}</td>,
    },
  ];

  return (
    <>

      {vertical === 'TVS' ? (
        <CardTitle title="Establecimientos TVS" />
      ): 
        <CardTitle title="Establecimientos Victory +" />
      }

      {openAddForm && (
        <>
        <EstablecimientosAdd
          form={form}
          vertical={vertical}
          isEdit={isEdit}
          controls={controls}
          ciudades={ciudades}
          onClose={onCloseForm}
          vehiculos={vehiculos}
          handleSubmit={handleSubmit}
          openAddToSocio={openAddForm}
          onChangeInputs={onChangeInputs}
        />
        </>
        
      )}
      {permitValue >= 2 ? (
        <Button color="warning" onClick={onOpenForm} className={classes.button}>
          Agregar Establecimiento
        </Button>
      ) : null}

      <SearchFilterSocios
        vertical={vertical}
        lineas={vehiculos}
        ciudades={filteredCities}
        handleChange={handleChange}
        departamentos={departamentos}
        controlComponent={controlComponent}
        handleChangeDepartment={handleChangeDepartment}
      />

      <TableType4
        hiddenDelete={permitValue < 4}
        hiddenEdit={permitValue < 3}
        onOpenDetails={onOpenDetails}
        pageSize={10}
        columns={columnsLeads}
        openForm={onOpenForm}
        onDelete={handleDelete}
        title="Establecimientos"
        dataTable={establecimientos}
      />

      <EstablecimientoDetails
        details={details}
        onClose={onCloseForm}
        openDetails={openDetails}
      />
    </>
  );
};

export default EstablecimientosPage;
